import { Value } from './types';

export const DEFAULT_PAGINATION_VALUE: Value = { page: 1, limit: 25 };
export const DEFAULT_LIMIT_SELECT_LABEL = 'Records per page';
export const DEFAULT_DISABLED_COLOR = 'rgba(15, 101, 229, 0.25)';
export const DEFAULT_ACTIVE_COLOR = '#0F65E6';
